import gql from 'graphql-tag';

const getGlobalAccountCardQuery = gql`
  query getGlobalAccountCardQuery {
    globalAccountCard {
      id
    }
  }
`;

export default getGlobalAccountCardQuery;
